import { hasTouch } from "../common/_helpers";

export function ComponentMember() {
  if (hasTouch()) {
    console.log('a');
    $('.member').on('click', function (e) {
      console.log('b');
      if ($(this).hasClass('hover')) {
        $('.member').removeClass('hover');
      } else {
        $('.member').removeClass('hover');
        $(this).addClass('hover');
      }
    });
  }
}
